import { styled } from '../../Styles/stitches.config'

export const StyledTooltip = styled('div', {
    bgc: '$neutral600',
    br: '$1',
    color: '$white',
    p: '$1 $2',
    fontSize: 14,
    w: 'max-content',
    zIndex: '$tooltip',
})

export const StyledReference = styled('div', {})
